/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrRippleModule } from './igr-ripple-module';
import { IgrChildContentModule } from "igniteui-react-core";
import { IgrCheckbox } from './igr-checkbox';
import { Checkbox } from './Checkbox';
import { TypeRegistrar } from "igniteui-react-core";
var IgrCheckboxModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrCheckboxModule() {
    }
    IgrCheckboxModule.register = function () {
        IgrRippleModule.register();
        IgrChildContentModule.register();
        TypeRegistrar.registerCons('IgrCheckbox', IgrCheckbox);
        TypeRegistrar.registerCons('IgrCheckbox', IgrCheckbox);
        TypeRegistrar.register('Checkbox', Checkbox.$type);
    };
    return IgrCheckboxModule;
}());
export { IgrCheckboxModule };
//# sourceMappingURL=igr-checkbox-module.js.map
